import { Controller } from "@hotwired/stimulus";
import Chart from "chart.js";

export default class extends Controller {
  static targets = ["ppsChart", "usersChart", "param"];

  initChart(path, element) {
    $.get(path)
      .done((response) => {
        // console.log(this.ppsChartTarget);
        const ppsChart = new Chart(element, {
          type: "doughnut",
          data: response,
          options: {
            // maintainAspectRatio: false,
            aspectRatio: 1,
            legend: {
              position: "right",
              labels: {
                padding: 20,
              },
            },
          },
        });
      })
      .fail((err) => console.log(err));
  }

  createPpChart() {
    let path;
    if (this.paramTarget) {
      path = `/pps.json${this.paramTarget.dataset.ppParam}`;
    } else {
      path = "/pps.json";
    }
    this.initChart(path, this.ppsChartTarget);
  }

  createUsersChart() {
    const path = "/users.json";
    this.initChart(path, this.usersChartTarget);
  }
}
